import React from "react";
import { Link } from "gatsby";
import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";
import sanityConfig from "../../../config/sanity";
import clsx from "clsx";

const MockupUI = ({ input, showCaption = true }) => {
  const { color, image, caption, link } = input;

  const imageData = getGatsbyImageData(
    image.asset,
    { maxWidth: 1000 },
    sanityConfig.sanity
  );
  const { aspectRatio } = input.image.asset.metadata.dimensions;
  // console.log(aspectRatio);
  return (
    <section
      className='mockupUI section'
      style={{
        backgroundColor: color ? color : "transparent"
      }}>
      <div className='inner'>
        <div className='p-sm md:p-md h-full'>
          <figure
            className={clsx(
              "p-md",
              aspectRatio < 1 ? "is-portrait" : "is-landscape"
            )}>
            <div className='bg-gray-100'>
              <GatsbyImage
                image={imageData}
                alt={"alt"}
                placeholder='blurred'
              />
            </div>
            {showCaption && (
              <figcaption className='absolute left-sm md:left-md bottom-md w-full text-sm-lg md:text-lg transition-opacity'>
                <div>{caption}</div>
                {link && link.link && (
                  <Link to={"/"} className='em'>
                    {link.label}
                  </Link>
                )}
              </figcaption>
            )}
          </figure>
        </div>
      </div>
    </section>
  );
};

export default MockupUI;
